"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var logo_html_purp_svg_1 = __importDefault(require("../assets/logo-html-purp.svg"));
var logo_css_purp_svg_1 = __importDefault(require("../assets/logo-css-purp.svg"));
var logo_js_purp_svg_1 = __importDefault(require("../assets/logo-js-purp.svg"));
var logo_react_purp_svg_1 = __importDefault(require("../assets/logo-react-purp.svg"));
var logo_node_purp_svg_1 = __importDefault(require("../assets/logo-node-purp.svg"));
function Skills() {
    var _a = (0, react_1.useState)({
        html: false,
        css: false,
        js: false,
        react: false,
        node: false
    }), logoFlip = _a[0], setLogoFlip = _a[1];
    var logoFlipper = function (event) {
        var id = event.target.id;
        setLogoFlip(function (prevLogoFlip) {
            var _a;
            return __assign(__assign({}, prevLogoFlip), (_a = {}, _a[id] = !prevLogoFlip[id], _a));
        });
        console.log(logoFlip);
    };
    return (react_1.default.createElement("section", { className: "skills" },
        react_1.default.createElement("h1", { className: "skills--title" }, "SKILLS"),
        react_1.default.createElement("div", { className: 'skills--container' },
            react_1.default.createElement("img", { src: logo_html_purp_svg_1.default, onClick: logoFlipper, className: logoFlip.html ? 'skills--icon html flipped' : 'skills--icon html', alt: 'html logo', id: 'html' }),
            react_1.default.createElement("img", { src: logo_css_purp_svg_1.default, onClick: logoFlipper, className: logoFlip.css ? 'skills--icon css flipped' : 'skills--icon css', alt: 'css logo', id: 'css' }),
            react_1.default.createElement("img", { src: logo_js_purp_svg_1.default, onClick: logoFlipper, className: logoFlip.js ? 'skills--icon js flipped' : 'skills--icon js', alt: 'js logo', id: 'js' }),
            react_1.default.createElement("img", { src: logo_react_purp_svg_1.default, onClick: logoFlipper, className: logoFlip.react ? 'skills--icon react flipped' : 'skills--icon react', alt: 'react logo', id: 'react' }),
            react_1.default.createElement("img", { src: logo_node_purp_svg_1.default, onClick: logoFlipper, className: logoFlip.node ? 'skills--icon node flipped' : 'skills--icon node', alt: 'node logo', id: 'node' }))));
}
exports.default = Skills;
